import { Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { Anchor } from './models/Anchor';

export const AnchorStore = types.compose(
  getBaseStore<Instance<typeof Anchor>, Instance<typeof Anchor>>(Anchor, 'anchorId', 'anchor'),
  types.model('AnchorStore', {}),
);

export type AnchorStoreType = Instance<typeof AnchorStore>;
